import { useState } from "react";
import { Badge, BadgeButton } from "./Badge.tsx";
import { SystemAuthorizationAdministration } from "../types.ts";

const MAX_VISIBLE_ADMINISTRATIONS = 4;

type AdministrationBadgeListProps = {
  administrations: SystemAuthorizationAdministration[] | null | undefined;
};

const AdministrationBadgeList = ({ administrations }: AdministrationBadgeListProps) => {
  const [expanded, setExpanded] = useState(false);

  if (!administrations?.length) {
    return <span className="text-zinc-400">Geen</span>;
  }

  const hiddenCount = administrations.length - MAX_VISIBLE_ADMINISTRATIONS;
  const visible = expanded || hiddenCount <= 0 ? administrations : administrations.slice(0, MAX_VISIBLE_ADMINISTRATIONS);

  return (
    <div className="flex flex-wrap gap-1">
      {visible.map((administration) => (
        <Badge key={administration.id}>{administration.name}</Badge>
      ))}
      {hiddenCount > 0 && (
        <BadgeButton
          color="primary"
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            setExpanded((prev) => !prev);
          }}
        >
          {expanded ? "minder tonen" : `+${hiddenCount} meer`}
        </BadgeButton>
      )}
    </div>
  );
};

export default AdministrationBadgeList;
